import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import Modal from "../../../shared/components/Modal";

const ModalAlertContext = createContext(null);

export const useModalAlert = () => {
  const context = useContext(ModalAlertContext);
  if (!context) {
    throw new Error("useModalAlert must be used within a ModalAlertProvider");
  }
  return context;
};

const initialAlertState = {
  isOpen: false,
  message: '',
  type: 'primary',
  onConfirm: () => {},
};

export const ModalAlertProvider = ({ children }) => {
  const [modalState, setModalState] = useState(initialAlertState);

  // Cierra el modal y limpia el estado
  const handleClose = useCallback(() => {
    setModalState(s => ({ ...s, isOpen: false }));
  }, []);

  // Lógica para el botón OK: ejecuta la acción y luego cierra
  const handleConfirm = useCallback(() => {
    if (modalState.onConfirm) {
        modalState.onConfirm();
    }
    handleClose();
  }, [modalState.onConfirm, handleClose]);

  const showModalAlert = useCallback((type, message, onConfirm = () => {}) => {
    setModalState({
      isOpen: true,
      type,
      message: message,
      onConfirm: onConfirm,
    });
  }, []);

  const contextValue = useMemo(() => ({
    showModalAlert
  }), [showModalAlert]);

  return (
    <ModalAlertContext.Provider value={contextValue}>
      {children}
      <Modal 
        color={modalState.type} 
        title={modalState.message}
        modal={modalState.isOpen}
        onOk={handleConfirm}
        toggle={handleClose} 
      />
    </ModalAlertContext.Provider>
  );
};
